import(/* webpackMode: "eager" */ "/opt/build/repo/packages/boat/src/app/(share-layout)/explore/page.tsx");
